export default "__VITE_ASSET__BkSb7Zlz__"